import { render, staticRenderFns } from "./EssayFeedback.vue?vue&type=template&id=72866d2f&"
import script from "./EssayFeedback.vue?vue&type=script&lang=js&"
export * from "./EssayFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports